import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardBgGrey: {
      padding: 40,
      background: '#e8eef4',
      fontStyle: 'italic',
      '@media only screen and (max-width: 600px)': {
        padding: 20,
      },
      '@media only screen and (max-width: 361px)': {
        padding: 15,
      },
    },
    bannerContainerOverride: {
      width: 350,
      [theme.breakpoints.down(1300)]: {
        width: 200,
      },
    },
    bannerTitleContainer: {
      margin: 'auto',
      marginTop: -92,
      [theme.breakpoints.down(1300)]: {
        marginTop: -96,
      },
    },
    bannerTitle: {
      fontStyle: 'normal',
      fontFamily: 'ITC Avant Garde Gothic Std Medium',
      color: 'white',
      fontSize: 20,
      textAlign: 'center',
      [theme.breakpoints.down(1300)]: {
        fontSize: 14,
      },
    },
    paragraphe: {
      fontSize: '15px',
      color: 'black',
      fontFamily: 'ITC Avant Garde Gothic Std Medium',
      marginTop: '10px',
      textAlign: 'justify',
      fontWeight: 'lighter',
      width: '90%',
      margin: '0 auto',
      '@media only screen and (max-width: 600px)': {
        textAlign: 'left !important',
      },
      '@media only screen and (max-width: 361px)': {
        textAlign: 'left !important',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        left: 0,
      },
    },
    img: {
      width: '110%',
      position: 'relative',
      left: '-5vh',
      [theme.breakpoints.down('sm')]: {
        width: '50%',
        left: 0,
      },
    },
  }),
);

export default useStyles;
